<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h2>
            <span v-if="openMarketInfo.shndHphnYn === 'Y'">중고폰&nbsp;</span>
            <span v-if="openMarketInfo.rsvSaleYn === 'Y'">예약판매&nbsp;</span>
            <!--[ST] [오픈마켓유심가입]2025.12.18 전승미 -->
            <span v-if="openMarketInfo.usimEntrAppfYn === 'Y'">USIM&nbsp;</span>
            <!--[ED] [오픈마켓유심가입]2025.12.18 전승미 -->
            가입신청내역 최종확인
          </h2>
        </div>
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              아래의 가입하신 정보는 회원님들의 동의 없이 공개되지 않으며,
              개인정보보호 정책에 의해 보호 받습니다.<br />
              LG유플러스 회원님의 개인정보보호를 위해 최선 +을 다할것을
              약속드립니다.
            </li>
            <li class="notice-text">
              아래 내용을 확인하시고 화면 하단 다음단계(본인인증)로 넘어가시기
              바랍니다.
            </li>
          </ul>
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h3>구매자정보 / 가입자 정보</h3>
          <a
            class="link-button secondary-button"
            id="btnMod1"
            href="#"
            target="_self"
            @click="backToPreviousStep('1')"
            title="입력사항 수정페이지로 화면전환"
            >수정</a
          >
        </div>
      </div>

      <!-- 구매자정보뷰 -->
      <div v-if="openMarketInfo.entrRqstFomNo">
        <BasicInformationSectionView :openMarketInfoProps="openMarketInfo" />
      </div>
      <!-- 가입자정보뷰 -->
      <div v-if="registration.appfNo && entrRsvTruthInfo.onetMblAppfNo">
        <CustomerSectionView
          :entrRsvTruthInfoProps="entrRsvTruthInfo"
          :registrationProps="registration"
        />
      </div>
      <!-- 법정대리인정보뷰 -->
      <div v-if="registration.custKdCd === 'A'">
        <div v-if="lawcAgntEntrRsvTruthInfo.onetMblAppfNo">
          <GuardianSectionView
            :lawcAgntEntrRsvTruthInfoProps="lawcAgntEntrRsvTruthInfo"
            :registrationProps="registration"
          />
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h3>가입내역 / 신청내역 / 선택사항</h3>
          <a
            class="link-button secondary-button"
            id="btnMod2"
            href="#"
            target="_self"
            @click="backToPreviousStep('2')"
            title="입력사항 수정페이지로 화면전환"
            >수정</a
          >
        </div>
      </div>

      <!-- 번호이동고객-->
      <div v-if="openMarketInfo.registrationTypeCode === 'move'">
        <TransferCompanySectionView :registrationProps="registration" />
      </div>

      <!-- 가입내역뷰 -->
      <div v-if="registration.appfNo && openMarketInfo.entrRqstFomNo">
        <DeviceSectionView
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
        />
      </div>

      <!-- 의무약정뷰 -->
      <div
        v-if="
          registration.dutyAgmtAgrYn === 'Y' &&
            openMarketInfo.entrRqstFomNo
        "
      >
        <RouterAgreedSectionView
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
        />
      </div>

      <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
      <div class="registration-page-container">
      <div
        class="section"
        v-if="this.openMarketInfo.mblSvcDivsCd === 'LZP0002200' && openMarketInfo.registrationTypeCode === 'new' 
         && registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct != '' && registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct != '0'
         && registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct != null"
      >
        <div class="section-header"><h3>요금할인약정</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              요금약정기간
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct}} 개월                  
                </p>
              </div>              
            </dd>
          </dl>
        </div>
      </div>      
      </div>
      <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->

      <!-- 부가서비스뷰 -->
      <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
      <div v-if="registration.appfNo && this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'">
        <AdditionalServiceSectionView :registrationProps="registration" />
      </div>
      <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->

      <!-- 보안선택사항뷰 -->
      <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
      <div v-if="registration.appfNo && this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'">
        <SecureOptionSectionView :registrationProps="registration" />
      </div>
      <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->

      <!-- 할부내역뷰 -->
      <!--[ST] [오픈마켓유심가입]2025.12.18 전승미 -->
      <div v-if="registration.appfNo && openMarketInfo.isttYn === 'Y' && openMarketInfo.shndHphnYn !== 'Y' && openMarketInfo.usimEntrAppfYn !== 'Y'">
      <!--[ED] [오픈마켓유심가입]2025.12.18 전승미 -->
        <InstallmentSectionView
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
        />
      </div>

      <!-- LTE -->
      <div v-if="openMarketInfo.rotrRqstCd === 'N' && formM2MYn === 'Y'">
        <LtePlusSectionView :openMarketInfoProps="openMarketInfo" />
      </div>

      <!-- 배송지 -->
      <div v-if="registration.appfNo">
        <ShipToAddrSectionView :registrationProps="registration" />
      </div>

      <div class="sub-section">
        <ul class="notice-text-list">
          <li class="notice-text">
            본인은 이동통신서비스 가입 신청내역, 각종 요금제, 이용에 관한 안내등
            약관의 중요내용 및 개인정보수집, 이용제공에 대하여 충분히 이해하고
            이에 동의하며 이용약관에 따라 위와같이 이동통신서비스를 신청하는
            바입니다.
          </li>
        </ul>
      </div>
      <!--            Penalty 안내-->
      <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
      <PenaltySectionView ref="penaltySectionView" v-if="this.openMarketInfo.mblSvcDivsCd != 'LZP0002200'" />
      <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->
      <!--            가입계약서교부방법-->
      <!--[ST] RITM2876892 M2M 요금약정기간 추가 건 -->
      <div v-if="registration.appfNo">
        <IssueWaySection
          :openMarketInfoProps="openMarketInfo"
          :registrationProps="registration"
          ref="issueWaySection"
        />
      </div>
      <!--[ED] RITM2876892 M2M 요금약정기간 추가 건 -->
      <div v-if="registration.appfNo &&
          (openMarketInfo.registrationTypeCode === 'move' ||
            openMarketInfo.registrationTypeCode === 'new')">
        <PayInformationSection
          :registrationProps="registration"
          ref="payInformationSection"
        />
      </div>
      <div class="step-bottom-area input-wrap">
        <button class="normal-button mw30" @click="deleteRegistration">
          삭제
        </button>
        <button
          class="primary-button mw100 pc-float-right"
          @click="saveAndContinueToIdentityVerification"
        >
          저장 후 본인인증
        </button>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import { watchRefreshKeyPress } from '@/system/common'
import CustomerSectionView from './CustomerSectionView'
import GuardianSectionView from './GuardianSectionView'
import DeviceSectionView from './DeviceSectionView'
import AdditionalServiceSectionView from './AdditionalServiceSectionView'
import LtePlusSectionView from './LtePlusSectionView'
import BasicInformationSectionView from './BasicInformationSectionView'
import TransferCompanySectionView from './TransferCompanySectionView'
import SecureOptionSectionView from './SecureOptionSectionView'
import InstallmentSectionView from './InstallmentSectionView'
import ShipToAddrSectionView from './ShipToAddrSectionView'
import IssueWaySection from './IssueWaySection'
import PayInformationSection from './PayInformationSection'
import PenaltySectionView from './PenaltySectionView'
import RouterAgreedSectionView from './RouterAgreedSectionView'

import {
  getRegistration,
  createRegistration,
  deleteRegistration
} from '@/api/captureService'
import { getOpenMarketInfo } from '@/api/openmarket'

import { actionType } from '@/store'
import { router } from '@/router/router'

//[ST][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기
import { getDevice } from '@/api/metaService' 
//[ED][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기

//[ST][CSR:RITM2694040] 안면인증 공통코드 가져오기
import { getFaceCommonCd } from '@/api/metaService' 
//[ED][CSR:RITM2694040] 안면인증 공통코드 가져오기

//[ST][CSR:RITM2694040] 안면인증 공통코드 가져오기
import { getComCodeList } from '@/api/metaService' 
//[ED][CSR:RITM2694040] 안면인증 공통코드 가져오기

export default {
  name: 'RegistrationStep3',

  props: {},
  data() {
    return {
      openMarketInfo: {
        dealNm: '',
        agentId: '',
        agentName: '',
        agentAddress: '',
        agentTelNo: '',
        sellerName: '',
        sellerAddress: '',
        sellerTelNo: '',
        sellerRegistrationNo: '',
        sbgnPosCd: '',
        sbgnPosNm: '',
        openMarketCode: '', //오픈마켓번호
        openMarketName: '',
        msBsType: '', //기업부문 BS
        entrRqstFomNo: '', //양식ID
        dealCd: '', //대리점코드
        opmkEntrKdCd: '', //가입유형코드
        isttYn: '', //할부여부
        isttAmt: '', //할부금액
        registrationTypeCode: '', //가입유형
        registrationTypeName: '', //가입유형명
        rotrRqstCd: '',
        shndHphnYn: '', //중고여부
        rcmdSaleKcCd: '', //추천판매 agmtTermMmct discGb
        mblSvcDivsCd: '', //G106M2MLZP0002200모바일서비스구분코드
        dataPpMndtYn: '', //데이터요금제 필수여부
        dlrGroup: '',
        resCode: '',
        resMsg: '',
        onetDealOrgDivsCd: '',
        appfTitNm: '',
        appfDutyAgmtAmt: '',
        crgrSaleYn: '',
        rqstCustDelKdCd: '',
        rqstOrdrNoTitNm: '',
        rqstTmpDutyAgmtAmt: '',
        onetRcmdSaleCd: '',
        appfUseStrtDttm: '',
        appfUseEndDttm: '',
        ppfUseYn: '',
        rqstBdlProdCd: '',
        rsvSaleNm: '',
        dcntKdNm: '',
        chocAgmtMmct: '',
        addSuptAmtUseYn: '',
        rotrRqstYn: '',
        svcDivsCd: '',
        rsvSaleYn: '',
        miltaryAgentYn: '',
        emalAddr: '',
        faxNo: '',
        chocAgmtDcntUseYn: ''   // 할인유형명
        // [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
        ,lrpsDiscOpenYn : 'N'   // 단통법폐지 프로젝트 오픈여부
        ,presaleTrmMdlCdYn:'N'    // 단통법폐지 프로젝트 오픈 전 사전예약판매단말여부
        ,presaleTrmMdlCdTxt : '' // 단통법폐지 프로젝트 오픈 전 사전예약판매단말ID(여러건인경우,구분자)
        ,dmbrYn:'N'               //직영점여부
        // [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
        // [ST] [오픈마켓유심가임] 2025.12.18 전승미
        ,usimEntrAppfYn : ''  //USIM가입신청서여부
        // [ED] [오픈마켓유심가입] 2025.12.18 전승미
      },
      registration: {
        dcntKdNm: '', // 할인유형명
        pymnBday: '', // 납부자생년월일
        appfNo: '', //신청서번호
        crypAppfNo: '', // 암호화 신청서번호
        rqstPgrsStusNm: '', //신청진행상태명
        onetKdCd: '', //가입유형코드
        onetKdNm: '', //가입유형명
        ppCd: '', //요금제코드
        sppsProdCdCntn: '', //부가서비스상품코드내용
        dataPpCd: '', //데이터요금제코드
        custKdCd: '', //고객유형코드
        aplcNm: '', //신청자명
        aplcDerno: '', //신청자주민등록번호--------------->최초
        aplcDernoMask: '', //신청자주민등록번호--------------->마스킹
        aplcTlno: '', //신청자전화번호
        aplcEmalAddr: '', //신청자이메일주소
        bltxRcepMthdCd: '', //청구서수령방법코드
        billDivsCd: '', //청구구분코드
        crplZpcd: '', //청구지우편번호
        crplAddr: '', //청구지주소
        crplDadr: '', //청구지상세주소
        pymnDivsCd: '', //납부자구분코드 TODO 본인:1 / 타인:2
        pymnNm: '', //납부자명 TODO 청소년이면 대리인
        pymnDerno: '', //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
        pymnEmalAddr: '', //납부자이메일주소 TODO 청소년이면 대리인
        paymMthdDivsCd: '', //납부방법구분코드
        bankNm: '', //은행명
        CdcoNm: '', //카드사명
        onetBankCd: '', //온라인가입은행코드
        onetCdcoCd: '', //온라인가입카드사코드
        acctCardNo: '', //계좌카드번호--------------->화면보기
        acctCardNoMask: '', //계좌카드번호마스킹
        ccrdValdTermEndYymm: '', //신용카드유효기간종료년월
        wdrwAgrYn: '', //출금동의여부
        mnpSoacTrgtCd: '', //번호이동정산대상코드
        mnpSoacNo: '', //번호이동정산번호
        noRnftEnprCd: '', //번호이동전사업자코드
        trmSrno: '', //단말시리얼번호
        dvicMdlCd: '', //단말기모델코드
        dvicMdlNm: '', //단말기모델명
        dvicColrCd: '', //단말기색상코드
        hphnColrNm: '', //휴대폰색상명
        chgHopTlno: '', //변경희망전화번호
        crgrBuyYn: 'N', //충전기구매여부
        ppNm: '', //요금제명
        dataPpNm: '', //데이터요금제명
        sppsProdNmCntn: '', //부가서비스상품명내용
        adltCntsIsolRqstYn: '', //성인컨텐츠차단신청여부
        agntEntrRstnYn: '', //대리인가입제한여부
        lawcAgntNm: '', //법정대리인명
        decLawcAgntCrypRrno: '', //------->입력
        lawcAgntCrypRrnoMask: '', //법정대리인암호화주민등록번호마스킹
        lawcAgntTlno: '', //법정대리인전화번호
        lawcAgntZpcd: '', //법정대리인우편번호
        lawcAgntAddr: '', //법정대리인주소
        lawcAgntDadr: '', //법정대리인상세주소
        isttTermMmct: '24', //할부기간개월수 halbuMonth
        tinsAmt: '0', //총할부금액 halbuPrice
        adseRqstDivsCd: '', //선결제신청구분코드
        lssInsrDivsNm: '', //분실보험구분명
        dcntDivsCd: '', //할인구분코드
        dcntTermMmct: '', //할인기간개월수 =agreedMonthM2M / discMonth
        dcntKdCd: '', //할인유형코드
        agmtTermMmct: '0', //약정기간개월수
        onsaAplyPlnNm: '', //온라인가입지원적용플랜명
        iphnUseAgrYn: '', //아이폰사용동의여부
        nwIsolYn: '', //네트워크차단여부
        entrAppfDvrMthdCd: '', //가입신청서교부방법코드
        entrAppfDvrMthdNm: '', //가입신청서교부방법명
        dlvRcipNm: '', //배송수령자명
        dlplZpcd: '', //배송지우편번호
        dlplBadr: '', //배송지기본주소
        dlplDadr: '', //배송지상세주소
        dlplTlno: '', //배송지전화번호
        dlvCtplNm: '', //배송연락처명
        custInfoGthrAgrYn: '', //고객정보수집동의여부
        pnifPuseTrstAgrYn: '', //개인정보활용위탁동의여부
        locFndnInfoOfrSvcAgrYn: '', //위치기반정보제공서비스동의여부
        autnMthdDivsCd: '', //인증방법구분코드
        prmsLinePcnt: '', //허용회선개수
        addReqMttrCntn: '', //추가요청사항내용
        dutyAgmtSuptAmt: '0', //의무약정지원금액 =dutyAgmtSuptAmt
        hphnInitStlmAmt: '', //휴대폰초기결제금액
        lssInsrCnslAgrYn: '', //분실보험상담동의여부
        dutyAgmtAgrYn: 'N', //의무약정동의여부 agreedAgreeYn
        rqstSppsCdCntn: '', //신청부가서비스코드내용
        dealAgmtAmt: '0', //대리점약정금액
        custBday: '', //고객생년월일
        lawcAgntAgrYn: '', //법정대리인동의여부
        smatAppUseYn: '', //스마트APP사용여부
        bukeAppUseYn: '', //사업지키미APP사용여부f
        rotrRqstYn: '', //라우터신청여부 formRoutrYn
        rotrAgmtMmct: '0', //라우터약정개월수
        rotrAgmtAmt: '0', //라우터약정금액
        browDivsCd: '', //브라우저구분코드
        rqstSppsNmCntn: '', //신청부가서비스명내용
        entrRqstFomNo: '', //가입신청양식번호
        opmkNo: '', //오픈마켓번호
        onlnAppfNo: '', //온라인신청서번호
        sbgnPosCd: '', //개통POS코드
        sbgnDealCd: '', //개통대리점코드
        dealNm: '', //대리점명
        opmkNm: '', //오픈마켓명
        svcDivsCd: '', //서비스구분코드
        shpnEntrRqstYn: '', //중고폰가입신청여부
        aplcNmMask: '', //마스킹 신청자명
        aplcTlnoMask: '', //마스킹 신청자전화번호
        aplcEmalAddrMask: '', //마스킹 신청자이메일주소
        lawcAgntNmMask: '', //마스킹 법정대리인명
        lawcAgntTlnoMask: '', //마스킹 법정대리인전화번호
        dlvRcipNmMask: '', //마스킹 배송수령자
        dlplTlnoMask: '', //마스킹 배송지전화번호
        dlplTlno2Mask: '', //마스킹 배송지전화번호 2
        //[ST] [오픈마켓유심가입] 2025.12.18 전승미
        trmStusDivsCd : '', //단말상태구분코드
        //[ED] [오픈마켓유심가입] 2025.12.18 전승미
        mobileRegistrationCaptureDetail:{
            onetAutnDivsCd:'',//인증방법상세
            g5CovrWideCtdoNm: '', //5G 시도
            g5CovrCcwNm: '', //5G 시군구
            g5CovrTwonNm: '' //5G 읍면동
            ,usimRqstYn:'' // USIM 신청 여부
            ,esimTrmYn:'' // eSIM 단말기 여부
            ,mnpCvrtSuptAmt:'' //전환지원금
            ,addCvrtSuptAmt:'' //추가전환지원금
            //[ST] RITM2876892 M2M 요금약정기간 추가 건
            ,m2mPpAgdcMmct:''
            ,m2mPpAgdcTermNm:''
            ,agdcRfunAgrYn:''
            //[ED] RITM2876892 M2M 요금약정기간 추가 건
          }
      },
      entrRsvTruthInfo: {
        onetMblAppfNo: '',
        onetIdcdDivsCd: '', //G116
        onetIndvDivsCd: '', //G117
        onetDivsCd: '', //G129
        agrYn: '',
        lawcAgntAgrYn: '',
        custNm: '',
        isuDt: '',
        drvLcnsNo: '', //초기입력
        drvLcnsNoMask: '', //화면
        crypDrvLcnsNo: '', //DB
        drvLcnsIsuAreaCd: '',
        bday: '',
        lawcAgntNm: '',
        coBrno: '',
        conmNm: '',
        monmCsntNo: ''
      },
      lawcAgntEntrRsvTruthInfo: {
        onetMblAppfNo: '',
        onetIdcdDivsCd: '', //G116
        onetIndvDivsCd: '', //G117
        onetDivsCd: '', //G129
        agrYn: '',
        lawcAgntAgrYn: '',
        custNm: '',
        isuDt: '',
        drvLcnsNo: '', //초기입력
        drvLcnsNoMask: '', //화면
        crypDrvLcnsNo: '', //DB
        drvLcnsIsuAreaCd: '',
        bday: '',
        lawcAgntNm: '',
        coBrno: '',
        conmNm: '',
        monmCsntNo: ''
      },
        openMarketAgrInfo: { //privacy 동의정보
          cupsifItemId: '',
          cupsifItemVerNo: '',
          cupsifItemNm: '',
          cupsifItemKdCd: '',
          cupsifYn: ''
        },      
      formM2MYn: '',
      //[ST][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기
      sdevYn: '',
      //[ED][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 전체 Skip 여부 가져오기
      faceAllSkipYn: '',
      //[ED][CSR:RITM2694040] 안면인증 전체 Skip 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 신규신청서 Skip 여부 가져오기
      faceNewSkipYn: '',
      //[ED][CSR:RITM2694040] 안면인증 신규신청서 Skip 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 번이신청서 Skip 여부 가져오기
      faceMoveSkipYn: '',
      //[ED][CSR:RITM2694040] 안면인증 번이신청서 Skip 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 기변신청서 Skip 여부 가져오기
      faceChgSkipYn: '',
      //[ED][CSR:RITM2694040] 안면인증 기변신청서 Skip 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 재가입신청서 Skip 여부 가져오기
      faceRenewSkipYn: '',
      //[ED][CSR:RITM2694040] 안면인증 재가입신청서 Skip 여부 가져오기
      //[ST][CSR:RITM2694040] 안면인증 카메라불허매장 Skip 여부 가져오기        
      facePosCdSkipYn: '', 
      //[ED][CSR:RITM2694040] 안면인증 카메라불허매장 Skip 여부 가져오기      
      
    }
  },

  computed: {
  },
  created() {
    watchRefreshKeyPress()
  },

  mounted() {

    this.openMarketAgrInfo = _.cloneDeep(this.$store.state.step1.openMarketAgrInfo) //privacy센터 추가
    //console.log("initPage this.openMarketAgrInfo step3:", this.openMarketAgrInfo);

    this.initPage()
    this.$store.state.processIndicator.step1 = false
    this.$store.state.processIndicator.step2 = false
    this.$store.state.processIndicator.step3 = true
    this.$store.state.processIndicator.step4 = false
  },

  components: {
    BasicInformationSectionView,
    TransferCompanySectionView,
    CustomerSectionView,
    GuardianSectionView,
    DeviceSectionView,
    AdditionalServiceSectionView,
    SecureOptionSectionView,
    InstallmentSectionView,
    LtePlusSectionView,
    ShipToAddrSectionView,
    PenaltySectionView,
    IssueWaySection,
    PayInformationSection,
    RouterAgreedSectionView
  },

  methods: {
    /** 
     * Function    : validateStep3
     * Description : Step3 필수값 validation
     **/
    validateStep3() {
      //[ST] RITM2876892 M2M 요금약정기간 추가 건
      if( this.formM2MYn != 'Y')
        if (!this.$refs.penaltySectionView.validCondition()) return false
      //[ED] RITM2876892 M2M 요금약정기간 추가 건
      if (!this.$refs.issueWaySection.validCondition()) return false
      this.registration = this.$refs.issueWaySection.saveIssueWaySection()
      if(this.openMarketInfo.registrationTypeCode === 'move' ||
         this.openMarketInfo.registrationTypeCode === 'new') {
        if (!this.$refs.payInformationSection.validCondition()) return false
        this.registration = this.$refs.payInformationSection.savePayInformationSection()
      }
      
      return true
    },

    /** 
     * Function    : initPage
     * Description : Step3 초기값 세팅
     **/
    initPage() {
      let applicationNumber = this.$store.state.applicationNumber
      if (applicationNumber !== '') {
        getRegistration(applicationNumber, "E").then(res => {
          let apiResponseJson = res.data
          this.registration = apiResponseJson.opmktRegistrationCapture // registration 저장
          this.getOpenMarketInfo(
            this.registration.sbgnDealCd,
            this.registration.entrRqstFomNo,
            this.registration.opmkNo
          ) // openmarketInfo 저장

          if (apiResponseJson.entrRsvTruthInfo !== null) {
            this.entrRsvTruthInfo = apiResponseJson.entrRsvTruthInfo
          }

          if (apiResponseJson.lawcAgntEntrRsvTruthInfo !== null) {
            this.lawcAgntEntrRsvTruthInfo =
              apiResponseJson.lawcAgntEntrRsvTruthInfo
          }

          //[ST][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기          
          getDevice(this.registration.dvicMdlCd).then(res => {
            this.sdevYn = res.data.sdevYn                               
            }            
          )
          //[ED][CSR:RITM2694040] 안면인증 세컨디바이스 여부 가져오기

          //[ST][CSR:RITM2694040] 안면인증 전체 Skip 여부 가져오기          
            getFaceCommonCd("G026", "FACE_ALL_SKIP").then(res => {
              this.faceAllSkipYn = res.data.cmmCdvNm                          
              }
            )
          //[ED][CSR:RITM2694040] 안면인증 전체 Skip 여부 가져오기

          //[ST][CSR:RITM2694040] 안면인증 신규신청서 Skip 여부 가져오기          
            getFaceCommonCd("G026", "FACE_NEW_SKIP").then(res => {
              this.faceNewSkipYn = res.data.cmmCdvNm                          
              }
            )
          //[ED][CSR:RITM2694040] 안면인증 신규신청서 Skip 여부 가져오기

          //[ST][CSR:RITM2694040] 안면인증 번이신청서 Skip 여부 가져오기          
            getFaceCommonCd("G026", "FACE_MOVE_SKIP").then(res => {
              this.faceMoveSkipYn = res.data.cmmCdvNm                          
              }
            )
          //[ED][CSR:RITM2694040] 안면인증 번이신청서 Skip 여부 가져오기

          //[ST][CSR:RITM2694040] 안면인증 기변신청서 Skip 여부 가져오기          
            getFaceCommonCd("G026", "FACE_CHG_SKIP").then(res => {
              this.faceChgSkipYn = res.data.cmmCdvNm                          
              }
            )
          //[ED][CSR:RITM2694040] 안면인증 기변신청서 Skip 여부 가져오기

          //[ST][CSR:RITM2694040] 안면인증 재가입신청서 Skip 여부 가져오기          
            getFaceCommonCd("G026", "FACE_RENEW_SKIP").then(res => {
              this.faceRenewSkipYn = res.data.cmmCdvNm                          
              }
            )
          //[ED][CSR:RITM2694040] 안면인증 재가입신청서 Skip 여부 가져오기
        })
      }
    },

    /** 
     * Function    : getOpenMarketInfo
     * Description : 오픈마켓 정보
     **/
    getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo) {
      if(!sbgnDealCd|| !entrRqstFomNo || !opmkNo) {
        this.openAlert(
          '온라인 가입신청 안내',
          '정보가 조회되지않았습니다.\n다시 접속후 신청서를 작성하여 주시기 바랍니다.'
        )
        return
      }
      getOpenMarketInfo(sbgnDealCd, entrRqstFomNo, opmkNo).then(res => {
        this.openMarketInfo = res.data
        this.openMarketInfo.agentId = sbgnDealCd
        this.openMarketInfo.dealCd = sbgnDealCd
        this.openMarketInfo.formId = entrRqstFomNo
        this.openMarketInfo.entrRqstFomNo = entrRqstFomNo
        this.openMarketInfo.openMarketCode = opmkNo
        if (this.openMarketInfo.mblSvcDivsCd === 'LZP0002200') {
          this.formM2MYn = 'Y' //ASIS agreedYn : 'none'
        } else {
          this.formM2MYn = 'N' //ASIS agreedYn : ''
        }

        //[ST][CSR:RITM2694040] 안면인증 불허매장 POSCD 가져오기          
        getComCodeList('ONET_CAM_UUSE_SHOP_CD').then(response => {
        
          let facePosCdList = response.data
                        
          for (let i = 0; i < facePosCdList.length; i++) {
            
            //console.log( "cmmCdv["+i+"] = " + facePosCdList[i].cmmCdv )
            if (facePosCdList[i].cmmCdv === this.openMarketInfo.sbgnPosCd) {
              this.facePosCdSkipYn = 'Y'
              break
            }else{
              this.facePosCdSkipYn = 'N'
            }
          }
                      
        })
        //[ED][CSR:RITM2694040]  안면인증 불허매장 POSCD 가져오기

        if (!this.openMarketInfo.entrRqstFomNo) {
          router.replace({
            name: 'Error',
            props: true,
            params: {
              message:
                '현재 접근 하신 경로는 올바르지 않은 접속 경로 입니다.\n올바른 경로를 통하여 다시 접속하여 주세요.',
              type: 'access'
            }
          })
        }
      })
    },

    /** 
     * Function    : saveAndContinueToIdentityVerification
     * Description : 단계 저장 후 본인인증으로 이동
     **/
    saveAndContinueToIdentityVerification() {
      if (!this.validateStep3()) return
      Object.assign(
        this.registration,
        {
          entrAppfDvrMthdCd: this.$refs.issueWaySection.registration
            .entrAppfDvrMthdCd
        },
        {
          entrAppfDvrMthdNm: this.$refs.issueWaySection.registration
            .entrAppfDvrMthdNm
        }
      )

      if(this.openMarketInfo.registrationTypeCode === 'move' ||
        this.openMarketInfo.registrationTypeCode === 'new') {
        Object.assign(
          this.registration,
          {
            ccrdValdTermEndYymm: this.$refs.payInformationSection.registration
              .ccrdValdTermEndYymm
          },
          {
            paymMthdDivsCd: this.$refs.payInformationSection.registration
              .paymMthdDivsCd
          },
          { wdrwAgrYn: this.$refs.payInformationSection.registration.wdrwAgrYn },
          {
            onetBankCd: this.$refs.payInformationSection.registration.onetBankCd
          },
          {
            onetCdcoCd: this.$refs.payInformationSection.registration.onetCdcoCd
          },
          { bankNm: this.$refs.payInformationSection.registration.bankNm },
          { CdcoNm: this.$refs.payInformationSection.registration.CdcoNm },
          { acctCardNo: this.$refs.payInformationSection.registration.acctCardNo }
        )
      }

      let title = '온라인 가입신청 안내'
      this.$modal.show('dialog', {
        title: '<h1>온라인 가입신청 안내</h1>',
        text: '신청서를 임시저장하시겠습니까?',
        buttons: [
          {
            title: '취소'
          },
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              createRegistration(
                this.registration,
                this.entrRsvTruthInfo,
                this.lawcAgntEntrRsvTruthInfo,
                this.openMarketAgrInfo, //privacy센터 추가
                3
              ).then(res => {
                let response = res.data.appfNo
                let crypAppfNo = res.data.crypAppfNo
                if (response !== '') {
                  this.$modal.show('dialog', {
                    title: '<h1>온라인 가입신청 안내</h1>',
                    text: '정상적으로 저장 되었습니다.',
                    buttons: [
                      {
                        title: '확인',
                        class: 'primary-button',
                        handler: () => {
                          this.$store.dispatch(
                            actionType.saveApplicationNumber,
                            crypAppfNo
                          )

                          this.$modal.hide('dialog')

                        /*  var url = location.href;
                          url = url.split('//');
                          url = url[1].substr(0,url[1].indexOf('/'));

                         */

                          /*if(this.registration.entrRqstFomNo=="1000000") {
                            this.$router.push({
                              name: 'IdentityVerificationSection2',//기존소스
                              params: {
                                registration: this.registration,
                                openMarketInfo: this.openMarketInfo
                              }
                            })
                          } else {*/

                            //[ST][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
                            //2026.07.02 M2M 안면인증 안하게 긴급반영 추가

                            //2026.07.07 주민등록증, 운전면허증만 안면인증하게 처리
                            //2026.07.07 안면인증 세컨디바이스일 경우 안면인증 안하게 처리
                            //2026.08.13 안면인증 신청서 양식별로 on-off 처리
                            //FACE_ALL_SKIP   : 장애시 전체 Skip
                            //FACE_NEW_SKIP   : 신규신청서 Skip
                            //FACE_MOVE_SKIP  : 번이신청서 Skip
                            //FACE_CHG_SKIP   : 기변신청서 Skip
                            //FACE_RENEW_SKIP : 재가입신청서 Skip
                            
                            //[ST]주민증, 운전면허증 제어로직
                            let faceAutnIdcdSkip = false

                            if( this.registration.lawcAgntAgrYn === 'Y' ){ //미성년자
                              if(this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'REGID' || this.lawcAgntEntrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE'){
                                faceAutnIdcdSkip = false  
                              }else{
                                faceAutnIdcdSkip = true
                              }
                            }else{
                              if( this.entrRsvTruthInfo.onetIdcdDivsCd === 'REGID' || this.entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE' ){
                                faceAutnIdcdSkip = false
                              }else{
                                faceAutnIdcdSkip = true
                              } 
                            }
                            //[ED]주민증, 운전면허증 제어로직

                            if( this.registration.custKdCd === 'D' || this.formM2MYn === 'Y' || faceAutnIdcdSkip === true
                               || this.sdevYn === 'Y' || this.facePosCdSkipYn === 'Y' || this.faceAllSkipYn === 'Y'
                               || (this.openMarketInfo.opmkEntrKdCd === 'new' && this.faceNewSkipYn === 'Y')
                               || (this.openMarketInfo.opmkEntrKdCd === 'move' && this.faceMoveSkipYn === 'Y')
                               || (this.openMarketInfo.opmkEntrKdCd === 'chg' && this.faceChgSkipYn === 'Y') //기변 renew로 세팅됨
                               || (this.openMarketInfo.opmkEntrKdCd === 'renew' && this.faceRenewSkipYn === 'Y')
                            ) {  
                              this.$router.push({
                                name: 'IdentityVerificationSectionNonFace',
                                params: {
                                  registration: this.registration,
                                  openMarketInfo: this.openMarketInfo,
                                  sdevYn: this.sdevYn,                   //안면인증 세컨디바이스 여부
                                  faceAllSkipYn: this.faceAllSkipYn,     //안면인증 전체Skip 여부
                                  faceNewSkipYn: this.faceNewSkipYn,     //안면인증 신규Skip 여부
                                  faceMoveSkipYn: this.faceMoveSkipYn,   //안면인증 번이Skip 여부
                                  faceChgSkipYn: this.faceChgSkipYn,     //안면인증 기변Skip 여부
                                  faceRenewSkipYn: this.faceRenewSkipYn, //안면인증 재가입Skip 여부
                                  formM2MYn: this.formM2MYn,             //안면인증 M2M 여부
                                  faceAutnIdcdSkip: faceAutnIdcdSkip,    //주민증, 운전면허증 여부
                                  facePosCdSkipYn: this.facePosCdSkipYn  //안면인증 불허매장 여부
                                }
                              })
                            }else{
                              this.$router.push({
                                name: 'IdentityVerificationSection',
                                params: {
                                  registration: this.registration,
                                  openMarketInfo: this.openMarketInfo
                                }
                              })
                            }
                            //[ED][CSR:RITM2694040] 안면인증 1차 시범서비스 - 외국인 안면인증 안하게 처리
                         // }

                        }
                      }
                    ]
                  })
                } else {
                  this.openAlert(title, '저장도중 오류가 발생했습니다.')
                  return false
                }
              })
            }
          }
        ]
      })
    },

    /** 
     * Function    : deleteRegistration
     * Description : 신청서 삭제
     **/
    deleteRegistration() {
      let title = '온라인 가입신청 안내'

      this.$modal.show('dialog', {
        title: '<h1>온라인 가입신청 안내</h1>',
        text: '신청서를 삭제하시겠습니까?',
        buttons: [
          {
            title: '취소'
          },
          {
            title: '확인',
            class: 'primary-button',
            handler: () => {
              this.$modal.hide('dialog')
              deleteRegistration(this.registration.appfNo).then(
                res => {
                  this.$modal.show('dialog', {
                    title: '<h1>온라인 가입신청 안내</h1>',
                    text: '정상적으로 삭제되었습니다.',
                    buttons: [
                      {
                        title: '확인',
                        class: 'primary-button',
                        handler: () => {
                          this.$router.push({
                            name: 'OpenMarket',
                            query: {
                              formId: this.openMarketInfo.entrRqstFomNo,
                              agentId: this.openMarketInfo.dealCd,
                              openmktCd: this.openMarketInfo.openMarketCode
                            }
                          })
                        }
                      }
                    ]
                  })
                }
              )
            }
          }
        ]
      })
    },

    /** 
     * Function    : backToPreviousStep
     * Description : 수정 버튼 클릭 이벤트
     **/
    backToPreviousStep(index) {
      if (index === '1') {
        this.$store.state.step2Accordion.isStep1 = true
        this.$store.state.step2Accordion.isStep2 = false
      } else if (index === '2') {
        this.$store.state.step2Accordion.isStep1 = false
        this.$store.state.step2Accordion.isStep2 = true
      }
      this.$router.push({
        name: 'RegistrationStep2'
      })
    },

    /** 
     * Function    : openAlert
     * Description : 기본 alert 호출 함수
     **/
    openAlert(title, message) {
      this.$modal.show('dialog', {
        title: title,
        text: message,
        buttons: [
          {
            title: '확인',
            class: 'primary-button'
          }
        ]
      })
    }
  }
}
</script>

<style scoped></style>
